import React, { Suspense, lazy } from 'react';

import useDeepResearchPageOperator from '@hooks/useDeepResearchPageOperator';

import SparkleSpinner from './SparkleSpinner';
import { Pages } from './constants';

const Chatbot = lazy(() => import('./Chatbot/index'));
const DeepResearchWelcome = lazy(() => import('./Welcome'));

const DeepResearchLayout = () => {
  const {
    handlePageTransition,
    isTransitioning,
    page,
    query,
    queryThreadID,
    suggestedPrompt,
    TrackThread,
    TrackWelcome,
  } = useDeepResearchPageOperator();

  return (
    <Suspense fallback={<SparkleSpinner className="mt-[30vh]" />}>
      <div
        className={isTransitioning ? 'opacity-0' : 'opacity-100 transition-[opacity] duration-500'}
      >
        {page === Pages.Welcome && handlePageTransition ? (
          <TrackWelcome>
            <DeepResearchWelcome
              querySubmitCallback={handlePageTransition}
              suggestedPromptInit={suggestedPrompt || ''}
            />
          </TrackWelcome>
        ) : page === Pages.Chatbot && (query || queryThreadID) ? (
          <TrackThread>
            <Chatbot query={query} queryThreadID={queryThreadID} />
          </TrackThread>
        ) : (
          <SparkleSpinner className="mt-[30vh]" />
        )}
      </div>
    </Suspense>
  );
};

export default DeepResearchLayout;
